import React, { useState, useRef } from "react";
import { Icon } from "../../components/Component";

const DirectLinkRow = ({ code }) => {
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const inputRef = useRef(null);

  const fullLink = `${code}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(fullLink).then(() => {
      setCopied(true);
      setShowTooltip(true);
      setTimeout(() => {
        setCopied(false);
        setShowTooltip(false);
      }, 1500);
    });
  };

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div style={{ position: "relative", display: "flex" }}>
        <input
          ref={inputRef}
          type="text"
          value={fullLink}
          readOnly
          style={{
            flex: 1,
            backgroundColor: "#f8fbff",
            border: "1px solid #ddd",
            borderRadius: 6,
            padding: "10px 40px 10px 10px",
            fontSize: 14,
          }}
        />
        <button
          onClick={handleCopy}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => !copied && setShowTooltip(false)}
          style={{
            position: "absolute",
            right: 10,
            top: "50%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <Icon name="copy"></Icon>
          {showTooltip && (
            <div
              style={{
                position: "absolute",
                top:-24,
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#333",
                color: "#fff",
                padding: "4px 8px",
                borderRadius: 4,
                fontSize: 11,
                whiteSpace: "nowrap",                
                zIndex: 1,
              }}
            >
              {copied ? "Copied!" : "Copy link"}
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default DirectLinkRow;
